import { createSlice } from "@reduxjs/toolkit";
import { isEmpty } from "lodash";

const initialState = {
  titles: [],
};

export const titleSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setTitle: (state, action) => {
      state.titles = action.payload;
      return state;
    },
  },
});

const titleReducer = titleSlice.reducer;

export const { setTitle } = titleSlice.actions;

export default titleReducer;
